import React from 'react'
import { eventKeyConstants  } from '../../utils/eventKey'

const noop = () => {}

export default React.forwardRef(({
  disabled,
  children,
  minWidth,
  style = {},
  fixedWidth,
  onClick = noop,
  onClose,
  className = null,
  maxHeight = Infinity,
  closeOnEsc = false,
  onEscPress = noop
}, ref) => {
  const _style = Object.assign({}, style, {
    pointerEvents: disabled ? 'none' : undefined
  })

  if (fixedWidth) {
    _style.width = `${fixedWidth}px`
  }

  if (minWidth) {
    _style.minWidth = `${minWidth}px`
  }

  if (maxHeight && isFinite(maxHeight)) {
    _style.maxHeight = `${maxHeight}px`
    _style.overflowY = 'scroll'
  }

  const closePopupOnEsc = (e) => {
    if (closeOnEsc) {
      e.preventDefault();
      if (e.key === eventKeyConstants.ESCAPE) {
        onClose();
        onEscPress();
      }
    }
  }

  return (
    <div
      className={['dropdown-menu', className].filter(name => name).join(' ')}
      onClick={onClick}
      onKeyDown = {(e) => closePopupOnEsc(e)}
      style={_style}
      ref={ref}
      id = 'menuId'
      role = 'menu'
      tabIndex = '-1'
    >
      { children}
    </div>
  )
})